export default "__VITE_ASSET__kMvrOy7s__"